import NorthEastIcon from '@mui/icons-material/NorthEast';
import { Link, Typography } from '@mui/material';

import { type ChangelogEntry } from '~/data/schemas/changelog';

export function WhatsNewEntryTitle({
  entry,
  onClick,
}: {
  entry: ChangelogEntry;
  onClick: () => void;
}) {
  if (!entry.url) return <Typography sx={{ fontWeight: 600 }}>{entry.title}</Typography>;
  return (
    <Link
      href={entry.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      underline="always"
      sx={{ fontWeight: 600 }}
    >
      {entry.title}
      <NorthEastIcon sx={{ fontSize: '0.8em', ml: 0.5, verticalAlign: '-0.05em' }} />
    </Link>
  );
}
